import * as tslib_1 from "tslib";
import { SelectionModel } from '@angular/cdk/collections';
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { CompanyApi } from '@api/companies.api';
import { debounceTime, map } from 'rxjs/operators';
var DialogChooseCompaniesComponent = /** @class */ (function () {
    function DialogChooseCompaniesComponent(data, matDialogRef, companiesApi) {
        var _a;
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.companiesApi = companiesApi;
        this.searchTerm = new FormControl();
        this.selectedCompaniesLimit = 4;
        this.selectedCompanies = [];
        this.isLoading = false;
        this.selectedCompaniesSelection = new SelectionModel(true, []);
        this.isLoadedAllTheCompanies = false;
        this.selectedCompaniesHasChanged = false;
        this.searchCompanyControl = new FormControl();
        this.companies = [];
        this.selectedCompaniesDefault = [];
        this.optionsLimit = 25;
        this.options = {
            limit: this.optionsLimit,
            offset: 0,
            orderBy: 'name_asc'
        };
        (_a = this.selectedCompaniesSelection).select.apply(_a, tslib_1.__spread(this.data.selectedCompanies.map(function (company) { return company.id; })));
        this.selectedCompaniesDefault = this.selectedCompaniesSelection.selected;
        this.selectedCompanies = tslib_1.__spread(this.data.selectedCompanies);
    }
    DialogChooseCompaniesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.searchCompanies();
        this.scrollableContent.nativeElement.addEventListener('scroll', function () {
            if (_this.isOnEndOfThePage() && !_this.isLoadedAllTheCompanies) {
                _this.loadMoreCompanies();
            }
        });
        this.searchTermSubscription = this.searchTerm.valueChanges
            .pipe(debounceTime(500), map(function () { return _this.companies = []; }), map(function () { return _this.options.offset = 0; }), map(function () { return (_this.searchTerm.value || '').trim().toLowerCase(); })).subscribe(function (searchTerm) {
            if (searchTerm) {
                _this.searchCompanies(searchTerm);
                return;
            }
            _this.searchCompanies();
        });
        this.selectedCompaniesSubscription = this.selectedCompaniesSelection.changed.subscribe(function () {
            _this.selectedCompaniesHasChanged = _this.hasSelectedCompaniesChanged();
        });
    };
    DialogChooseCompaniesComponent.prototype.ngOnDestroy = function () {
        this.searchTermSubscription.unsubscribe();
        this.selectedCompaniesSubscription.unsubscribe();
    };
    DialogChooseCompaniesComponent.prototype.searchCompanies = function (searchTerm) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, options, companies;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        query = { name_contains: searchTerm && searchTerm.name ? searchTerm.name : searchTerm };
                        options = {
                            limit: this.options.limit,
                            offset: this.options.offset,
                            orderBy: this.options.orderBy
                        };
                        return [4 /*yield*/, this.companiesApi.search(query, options).toPromise()];
                    case 1:
                        companies = (_b.sent()).items;
                        (_a = this.companies).push.apply(_a, tslib_1.__spread(companies));
                        this.isLoading = false;
                        if (companies.length < this.optionsLimit) {
                            this.isLoadedAllTheCompanies = true;
                            return [2 /*return*/];
                        }
                        this.isLoadedAllTheCompanies = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogChooseCompaniesComponent.prototype.toggleCompany = function (newSelectedCompany) {
        var alreadySelected = this.selectedCompaniesSelection.isSelected(newSelectedCompany.id);
        var didntReachTheLimit = this.selectedCompaniesSelection.selected.length < this.selectedCompaniesLimit;
        if (!alreadySelected && didntReachTheLimit) {
            this.selectedCompaniesSelection.select(newSelectedCompany.id);
            this.selectedCompanies.push(newSelectedCompany);
        }
        else {
            this.selectedCompaniesSelection.deselect(newSelectedCompany.id);
            this.selectedCompanies = this.selectedCompanies.filter(function (selectedCompany) { return selectedCompany.id !== newSelectedCompany.id; });
        }
    };
    DialogChooseCompaniesComponent.prototype.isOnEndOfThePage = function () {
        var scrollableElement = this.scrollableContent.nativeElement;
        return Math.abs(scrollableElement.scrollHeight - scrollableElement.clientHeight - scrollableElement.scrollTop) < 1;
    };
    DialogChooseCompaniesComponent.prototype.loadMoreCompanies = function () {
        this.options.offset += this.options.limit;
        this.searchCompanies();
    };
    DialogChooseCompaniesComponent.prototype.hasSelectedCompaniesChanged = function () {
        var e_1, _a;
        if (this.selectedCompaniesDefault.length !== this.selectedCompaniesSelection.selected.length) {
            return true;
        }
        var _loop_1 = function (alreadySelectedCompany) {
            var matchingObj = this_1.selectedCompaniesSelection.selected.find(function (newSelectedCompany) { return newSelectedCompany === alreadySelectedCompany; });
            if (!matchingObj) {
                return { value: true };
            }
        };
        var this_1 = this;
        try {
            for (var _b = tslib_1.__values(this.selectedCompaniesDefault), _c = _b.next(); !_c.done; _c = _b.next()) {
                var alreadySelectedCompany = _c.value;
                var state_1 = _loop_1(alreadySelectedCompany);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    DialogChooseCompaniesComponent.prototype.compare = function () {
        if (!this.selectedCompaniesHasChanged || this.isLoading) {
            return;
        }
        this.matDialogRef.close({
            data: {
                selectedCompanies: this.selectedCompanies
            }
        });
    };
    return DialogChooseCompaniesComponent;
}());
export { DialogChooseCompaniesComponent };
